import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { devicePixelRatio, Modalconfig, DefaultLanguageId } from 'src/app/shared/constants';
import { PlaybookCommunicationService } from '../../shared/services/playbook-communication.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ContentBlock, ImageBlock, ImageGroup } from 'src/app/shared/model/container.models';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { AddImageComponent } from '../../shared/components/add-image/add-image.component';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { clone } from 'lodash';
@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
    standalone: false
})
export class ImageComponent implements OnInit, OnDestroy {

  @Input('contentBlock') contentBlock: ContentBlock;
  @Input() sectionId: number;
  @Input() containerId: number;
  @Input() isdraftmode: boolean;
  @Input() pageTemplateId: number;
  @ViewChild('contentImage') contentImage;
  devicePixelRatio = devicePixelRatio;
  showImage: boolean;
  width: number;
  imageLoaded = false;
  // When an image is uploaded/edited via the modal, the freshly inserted <img>
  // starts display:none ([hidden]="!imageLoaded"). A native loading="lazy"
  // image that is display:none never enters the viewport, so the browser never
  // loads it, (load) never fires and the placeholder spins forever. For a
  // just-uploaded image we therefore disable lazy loading so it loads eagerly.
  disableLazyLoad = false;
  eventSub: boolean;
  updateSubsciption: Subscription;
  modalRef: BsModalRef;
  defaultLanguageId = DefaultLanguageId;
  languageId: number;
  imageContentSubscription: Subscription;
  constructor(
    private commService: PlaybookCommunicationService,
    private commonHttpService: CommonHttpService,
    private modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private storage: LocalStorageService
  ) { }

  ngOnInit() {
    this.languageId = +this.activatedRoute.snapshot.queryParams.languageId || this.defaultLanguageId;
    // To handle Add/Edit modal opening when clicked from settings wrapper
    this.updateSubsciption = this.commService.getAddEditContentBlock().subscribe((contentBlockId) => {
      if (this.contentBlock.id === contentBlockId) {
        if (!this.contentBlock.imageBlock) {
          this.contentBlock.imageBlock = new ImageBlock();
        }
        if (this.pageTemplateId !== null) {
          this.openImageModal(null);
        } else {
          const reqObj = {
            playbookId: this.contentBlock.playbookId,
            languageId: this.languageId
          };
          this.commonHttpService.post<any, ImageGroup[]>({
            uri: `/api/ImageBlocks/GetPlaybookImageGroups`,
            object: reqObj
          }).subscribe(response => {
            this.openImageModal(response)
          });
        }
      }
    });
    // to handle hotspot string
    if (this.contentBlock.imageBlock && this.contentBlock.imageBlock.hotspotHtmlString) {
      this.contentBlock.imageBlock.hotspotHtmlString = this.handleHotspotString(this.contentBlock.imageBlock.hotspotHtmlString);
    }
  }

  openImageModal(imageGroups = null) {
    const initialState = {
      contentBlock: this.contentBlock,
      items: imageGroups,
      pageId: this.containerId,
      sectionId: this.sectionId,
      isdraftmode: this.isdraftmode,
      pageTemplateId: this.pageTemplateId
    };
    if ((window === window.parent || ( (window != window.parent) && window.location != window.parent.location ))) {
      this.modalRef = this.modalService.show(AddImageComponent,
        Object.assign({ initialState }, { class: 'custom-modal ' }, Modalconfig));
      // Once the upload/edit modal closes, the image may have just been
      // uploaded. Disable lazy loading and reset the loaded flag so the new
      // asset loads eagerly instead of deadlocking the placeholder spinner.
      this.modalService.onHidden.pipe(take(1)).subscribe(() => {
        this.disableLazyLoad = true;
        this.imageLoaded = false;
      });
    } else {
      this.imageContentSubscription = this.storage.observe('uploadImageContent')
      .subscribe((uploadContentBlock) => {
        if ((window !== window.parent && window.location == window.parent.location) && uploadContentBlock) {
          this.contentBlock = clone(uploadContentBlock);
          this.disableLazyLoad = true;
          this.imageLoaded = false;
        }
      });
      this.storage.store("imageContentBlock", {
        contentBlock: this.contentBlock,
        items: imageGroups,
        pageId: this.containerId,
        sectionId: this.sectionId,
        isdraftmode: this.isdraftmode,
        pageTemplateId: this.pageTemplateId,
      });
    }
  }

  /**
  * To change hotspot string to make it compatible with new viewer
  * @param str hotspot string
  */
  handleHotspotString(str: string) {
    let newStr = str.replace(/background:.+?(?=;)/g, 'background: none');
    newStr = newStr.replace(/\/Content\/images\//g, 'assets/img/');
    newStr = newStr.replace(/opacity: 0/g, 'opacity: 1');
    newStr = newStr.replace(/\/assets\/image\/.+?(?=")/g, '');
    newStr = newStr.replace(/↵/g, '');
    return newStr;
  }
  /**
   * To check if imageBlock have image url or not
   */
  hasImage(imageBlock: ImageBlock) {
    return (imageBlock != null && imageBlock.url != null && imageBlock.url != '');
  }

  /**
   * To set the image asset
   */
  getImageUrl(imageBlock: ImageBlock) {
    if (imageBlock.assetId) {

      this.width = $('#image-container-' + this.contentBlock.imageBlock.id).width();
      if (this.width === 0 || this.width === undefined) {
        this.width = 1024;
      }
      return `/api/Assets/Image/${imageBlock.assetId}?width=${this.getAdjustedWidth(100, this.width)}&ratio=${this.devicePixelRatio}`;
    }
    return '';
  }

  /**
   * To round off image width
   */
  getAdjustedWidth(v: number, num: number) {
    const percx = (num + v - 1);
    return (percx - (percx % v));
  }

  /**
   * To set placeholder for images
   */
  getPlaceHolder() {
    return 'data:image/gif;base64,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';
  }

  /**
  * To set style for images containing hotspot string
  * @param id image block id
  */
  setHotspotImageStyle(id) {
    setTimeout(() => {
      const height = $('#image-' + id).height();
      $('#hp-container-' + id).css({ 'padding-bottom': height + 'px' });
    }, 0);
  }


  ngOnDestroy() {
    if (this.updateSubsciption) {
      this.updateSubsciption.unsubscribe();
    }
    if (this.imageContentSubscription) {
      this.imageContentSubscription.unsubscribe();
      this.storage.store("uploadImageContent", null);
    }
  }
}
